import { render, staticRenderFns } from "./register-enterprise.vue?vue&type=template&id=1640c746&scoped=true"
import script from "./register-enterprise.vue?vue&type=script&lang=js"
export * from "./register-enterprise.vue?vue&type=script&lang=js"
import style0 from "./register-enterprise.vue?vue&type=style&index=0&id=1640c746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1640c746",
  null
  
)

export default component.exports